import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  goToPage (event) {
    this.dispatch('paginate', { detail: { page: event.params.page } })
  }
}
